import React from "react";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

function DONarrationHistoryModal({ open, onClose, entries = [] }) {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        display: "flex", alignItems: "center", justifyContent: "center",
        background: "rgba(0,0,0,0.5)", padding: 16,
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: "relative", background: "white", borderRadius: 16,
          boxShadow: "0 20px 60px rgba(0,0,0,0.18)", display: "flex",
          flexDirection: "column", width: "100%", maxWidth: 520,
          maxHeight: "80vh",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "14px 18px", background: "#fef2f2",
          borderBottom: "1px solid #fecaca", borderRadius: "16px 16px 0 0",
          flexShrink: 0,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{
              width: 34, height: 34, borderRadius: 9,
              background: "#fee2e2", display: "flex",
              alignItems: "center", justifyContent: "center", flexShrink: 0,
            }}>
              <ReportProblemIcon style={{ fontSize: 18, color: "#dc2626" }} />
            </div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 600, color: "#991b1b" }}>
                Unapproved DO — Correction History
              </div>
              <div style={{ fontSize: 11.5, color: "#b91c1c", marginTop: 1 }}>
                {entries.length} update{entries.length !== 1 ? "s" : ""}
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none", border: "none", fontSize: 20, lineHeight: 1,
              color: "#991b1b", cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        <div style={{ padding: 18, overflowY: "auto", flex: 1 }}>
          {entries.length === 0 ? (
            <div style={{ textAlign: "center", color: "#94a3b8", fontSize: 13, padding: "30px 0" }}>
              No narration history available.
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {entries.map((entry, i) => (
                <div
                  key={i}
                  style={{
                    padding: "10px 14px", borderRadius: 10,
                    background: "#fef2f2", border: "1.5px solid #fecaca",
                  }}
                >
                  <div style={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    marginBottom: 4,
                  }}>
                    <span style={{
                      fontSize: 10, fontWeight: 700, color: "#dc2626",
                      background: "#fee2e2", padding: "2px 8px", borderRadius: 50,
                    }}>
                      Update {i + 1}
                    </span>
                    {entry.date && (
                      <span style={{ fontSize: 11, color: "#b91c1c", fontWeight: 600 }}>
                        {entry.date}
                      </span>
                    )}
                  </div>
                  <div style={{ fontSize: 13, color: "#991b1b", fontWeight: 600, lineHeight: 1.4 }}>
                    {entry.text || "-"}
                  </div>
                  {entry.user && (
                    <div style={{ fontSize: 11, color: "#b91c1c", marginTop: 4, opacity: 0.8 }}>
                      Query Generated By: {entry.user}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={{
          display: "flex", justifyContent: "flex-end",
          padding: "12px 18px", borderTop: "1px solid #e2e8f0",
        }}>
          <button
            onClick={onClose}
            style={{
              padding: "7px 16px", borderRadius: 8, border: "1px solid #cbd5e1",
              background: "white", color: "#334155", fontSize: 13, fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default DONarrationHistoryModal;
